import request from 'api/requestUtils'

import type { WrappedData } from 'components/Pages/Wrapped/types/wrapped'
import mapWrappedResponse from './mapWrappedResponse'
import { ServerWrappedResponse } from './types'

export async function getMyWrapped(): Promise<WrappedData> {
  const response = await request.get<ServerWrappedResponse>(
    '/api/carts/wrapped/me',
    { credentials: 'include' },
  )
  return mapWrappedResponse(response)
}

export async function getSharedWrapped(uuid: string): Promise<WrappedData> {
  const response = await request.get<ServerWrappedResponse>(
    `/api/carts/wrapped/${uuid}`,
  )
  return mapWrappedResponse(response)
}
